import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { key: 2 };
const _hoisted_6 = { key: 4 };
const _hoisted_7 = {
    key: 5,
    class: "py-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormInput = _resolveComponent("FormInput");
    const _component_FormSelect = _resolveComponent("FormSelect");
    const _component_HwDeviceField = _resolveComponent("HwDeviceField");
    const _component_FormSelectMultiple = _resolveComponent("FormSelectMultiple");
    const _component_ServiceLimits = _resolveComponent("ServiceLimits");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.technology === 'LORA')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_FormInput, {
                    class: "mb-3",
                    "has-error": _ctx.containsError && !_ctx.device.deviceId,
                    "info-text": 'info_import_deviceId',
                    "info-tooltip": 'tooltip_import_deviceId',
                    label: _ctx.$t('idZarizeni'),
                    maxlength: 16,
                    value: _ctx.device.deviceId,
                    onInput: _cache[0] || (_cache[0] = ($event) => (_ctx.device.deviceId = $event))
                }, null, 8, ["has-error", "label", "value"]),
                _createVNode(_component_FormSelect, {
                    class: "mb-3",
                    "has-error": _ctx.containsError && !_ctx.device.selectedType,
                    "info-text": 'info_import_zpusobAktivace',
                    "info-tooltip": 'tooltip_import_zpusobAktivace',
                    "item-text": "text",
                    "item-value": "value",
                    items: _ctx.deviceTypeOptions,
                    label: _ctx.$t('zpusobAktivace'),
                    value: _ctx.device.selectedType,
                    onChange: _ctx.handleTypeChanged
                }, null, 8, ["has-error", "items", "label", "value", "onChange"]),
                (_ctx.device.selectedType.value === 'ABP')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_FormInput, {
                            class: "mb-3",
                            "has-error": _ctx.containsError && !_ctx.device.nwkSKey,
                            "info-text": 'info_import_nwkSKey',
                            "info-tooltip": 'tooltip_import_nwkSKey',
                            label: _ctx.$t('NwkSKey'),
                            maxlength: 32,
                            value: _ctx.device.nwkSKey,
                            onInput: _cache[1] || (_cache[1] = ($event) => (_ctx.device.nwkSKey = $event))
                        }, null, 8, ["has-error", "label", "value"]),
                        _createVNode(_component_FormInput, {
                            class: "mb-3",
                            "has-error": _ctx.containsError && !_ctx.device.appSKey,
                            "info-text": 'info_import_appSKey',
                            "info-tooltip": 'tooltip_import_appSKey',
                            label: _ctx.$t('AppSKey'),
                            maxlength: 32,
                            value: _ctx.device.appSKey,
                            onInput: _cache[2] || (_cache[2] = ($event) => (_ctx.device.appSKey = $event))
                        }, null, 8, ["has-error", "label", "value"]),
                        _createVNode(_component_FormInput, {
                            class: "mb-3",
                            "has-error": _ctx.containsError && !_ctx.device.devAddr,
                            "info-text": 'info_import_deviceAddress',
                            "info-tooltip": 'tooltip_import_deviceAddress',
                            label: _ctx.$t('DeviceAddress'),
                            maxlength: 8,
                            value: _ctx.device.devAddr,
                            onInput: _cache[3] || (_cache[3] = ($event) => (_ctx.device.devAddr = $event))
                        }, null, 8, ["has-error", "label", "value"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.device.selectedType.value === 'OTAA')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_FormInput, {
                            class: "mb-3",
                            "has-error": _ctx.containsError && !_ctx.device.appeui,
                            "info-text": 'info_import_appEUI',
                            "info-tooltip": 'tooltip_import_appEUI',
                            label: _ctx.$t('AppEUI'),
                            maxlength: 16,
                            value: _ctx.device.appeui,
                            onInput: _cache[4] || (_cache[4] = ($event) => (_ctx.device.appeui = $event))
                        }, null, 8, ["has-error", "label", "value"]),
                        _createVNode(_component_FormInput, {
                            class: "mb-3",
                            "has-error": _ctx.containsError && !_ctx.device.appKey,
                            "info-text": 'info_import_appKey',
                            "info-tooltip": 'tooltip_import_appKey',
                            label: _ctx.$t('AppKey'),
                            maxlength: 32,
                            value: _ctx.device.appKey,
                            onInput: _cache[5] || (_cache[5] = ($event) => (_ctx.device.appKey = $event))
                        }, null, 8, ["has-error", "label", "value"])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_FormSelect, {
                    class: "mb-3",
                    "has-error": _ctx.containsError && !_ctx.device.profileId,
                    "item-text": "profileName",
                    "item-value": "profileId",
                    "item-subtext": "subText",
                    "subtext-font-size": "12px",
                    items: _ctx.importProfileList.map((profile) => ({
                        ...profile,
                        subText: `${_ctx.$t('jakZarizeniNasloucha')}: ${_ctx.getDeviceClassDescription(profile.class)}
              ${_ctx.$t('Minimální ADR datarate')}: ${profile.adrMin ?? 'X'}
              ${_ctx.$t('Maximální ADR datarate')}: ${profile.adrMax ?? 'X'}
              ID: ${profile.profileId}`
                    })),
                    label: _ctx.$t('IMPORT_PROFILE'),
                    value: _ctx.device.profileId,
                    onChange: _cache[6] || (_cache[6] = ($event) => (_ctx.device.profileId = $event.profileId))
                }, null, 8, ["has-error", "items", "label", "value"])
            ]))
            : _createCommentVNode("", true),
        (['MQTT', 'UDP'].includes(_ctx.technology))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_FormInput, {
                    class: "mb-3",
                    "has-error": _ctx.containsError && !_ctx.device.deviceId,
                    "info-text": 'info_import_deviceId',
                    "info-tooltip": 'tooltip_import_deviceId',
                    label: _ctx.$t('idZarizeniMQTT'),
                    maxlength: 16,
                    value: _ctx.device.deviceId,
                    onInput: _cache[7] || (_cache[7] = ($event) => (_ctx.device.deviceId = $event))
                }, null, 8, ["has-error", "label", "value"])
            ]))
            : _createCommentVNode("", true),
        (_ctx.technology === 'MQTT')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_FormInput, {
                    class: "mb-3",
                    "has-error": _ctx.containsError && !_ctx.device.username,
                    "info-text": 'info_import_username',
                    "info-tooltip": 'tooltip_import_username',
                    label: _ctx.$t('USERNAME'),
                    value: _ctx.device.username,
                    onInput: _cache[8] || (_cache[8] = ($event) => (_ctx.device.username = $event))
                }, null, 8, ["has-error", "label", "value"]),
                _createVNode(_component_FormInput, {
                    class: "mb-3",
                    "has-error": _ctx.containsError && !_ctx.device.password,
                    "info-text": 'info_import_username',
                    "info-tooltip": 'tooltip_import_username',
                    label: _ctx.$t('PASSWORD'),
                    type: "password",
                    value: _ctx.device.password,
                    onInput: _cache[9] || (_cache[9] = ($event) => (_ctx.device.password = $event))
                }, null, 8, ["has-error", "label", "value"]),
                _createVNode(_component_FormInput, {
                    class: "mb-3",
                    "has-error": _ctx.containsError && !_ctx.device.confirmPassword,
                    "info-text": 'info_import_confirmPassword',
                    "info-tooltip": 'tooltip_import_confirmPassword',
                    label: _ctx.$t('CONFIRM_PASSWORD'),
                    type: "password",
                    value: _ctx.device.confirmPassword,
                    onInput: _cache[10] || (_cache[10] = ($event) => (_ctx.device.confirmPassword = $event))
                }, null, 8, ["has-error", "label", "value"])
            ]))
            : _createCommentVNode("", true),
        (['LORA', 'UDP'].includes(_ctx.technology))
            ? (_openBlock(), _createBlock(_component_HwDeviceField, {
                key: 3,
                technology: _ctx.technology,
                value: _ctx.device.hwDeviceId,
                "has-error": _ctx.containsError && !_ctx.device.hwDeviceId,
                class: "mb-3",
                onChange: _cache[11] || (_cache[11] = ($event) => (_ctx.device.hwDeviceId = $event)),
                onPayloadDecodeChanged: _cache[12] || (_cache[12] = ($event) => (_ctx.device.payloadDecode = $event))
            }, null, 8, ["technology", "value", "has-error"]))
            : _createCommentVNode("", true),
        (['LORA', 'MQTT', 'UDP'].includes(_ctx.technology))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_FormSelectMultiple, {
                    class: "mb-3",
                    "info-text": 'info_import_tagy',
                    "info-tooltip": 'tooltip_import_tagy',
                    "item-text": "text",
                    "item-value": "value",
                    items: _ctx.tagOptions,
                    label: _ctx.$t('tags'),
                    value: _ctx.device.tags,
                    onChange: _cache[13] || (_cache[13] = ($event) => (_ctx.device.tags = $event))
                }, null, 8, ["items", "label", "value"]),
                _createVNode(_component_FormSelect, {
                    class: "mb-3",
                    "has-error": _ctx.containsError && !_ctx.device.custServiceId,
                    "info-text": 'info_import_prirazeniKeSluzbe',
                    "info-tooltip": 'tooltip_import_prirazeniKeSluzbe',
                    "item-text": "custServiceName",
                    "item-value": "custServiceId",
                    "item-subtext": "custServiceId",
                    items: _ctx.availableServicesForTechnology,
                    label: _ctx.$t('prirazeniKeSluzbe'),
                    value: _ctx.device.selectedService,
                    onChange: _ctx.handleServiceChange
                }, null, 8, ["has-error", "items", "label", "value", "onChange"]),
                (_ctx.device.selectedService?.parameters)
                    ? (_openBlock(), _createBlock(_component_ServiceLimits, {
                        key: 0,
                        service: _ctx.device.selectedService
                    }, null, 8, ["service"]))
                    : _createCommentVNode("", true),
                _createVNode(_component_FormSelect, {
                    class: "mb-3",
                    "info-text": 'info_import_spustitZarizeniDoRezimu',
                    "info-tooltip": 'tooltip_import_spustitZarizeniDoRezimu',
                    "item-text": "text",
                    "item-value": "value",
                    items: _ctx.stateOptions,
                    label: _ctx.$t('spustitZarizeniDoRezimu'),
                    value: _ctx.device.selectedState,
                    onChange: _cache[14] || (_cache[14] = ($event) => (_ctx.device.selectedState = $event))
                }, null, 8, ["items", "label", "value"])
            ]))
            : _createCommentVNode("", true),
        (_ctx.technology === 'HTTP')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.$t("NO_SERVICE_FOR_HTTP")) + " ", 1),
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1))
            ]))
            : _createCommentVNode("", true)
    ]));
}
